module.exports = __webpack_public_path__ + "static/media/slide_diversify_efficient_frontier.c1f94f2e.png";